export const SEARCH_GIFS = "SEARCH_GIFS";
export const SEARCH_FAV_GIFS = "SEARCH_FAV_GIFS";
export const SET_LOADING = "SET_LOADING";
export const SET_FAV = "SET_FAV";
export const REMOVE_FAV = "REMOVE_FAV";
export const GET_NOT_FOUND_GIF = 'GET_NOT_FOUND_GIF';
